import React from "react";
import axios from "axios";
import { Inbox } from "lucide-react";
import { InboxList } from "./InboxList";
import { PageSizeSelect, ShowMoreButton, BulkDeleteButton } from "./ListControls";
import { INBOX_PAGE_KEY } from "./NotificationBell";
import { usePageSize, usePagedList, notifyInboxChanged } from "../../utils/pagedList";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Ж12/Ж22: блок «Внутрисайтовые уведомления» на странице настроек — порции, удаление
export const InboxSettingsBlock = ({ onOpenTask }) => {
  const [size, setSize] = usePageSize(INBOX_PAGE_KEY);
  const list = usePagedList(`${API}/notifications/inbox`, size);

  const markAll = async () => {
    try {
      const r = await axios.post(`${API}/notifications/inbox/mark-read`, {});
      list.setUnread(r.data.unread || 0);
      list.setItems((prev) => prev.map((n) => ({ ...n, read: true })));
      notifyInboxChanged();
    } catch (e) { /* не критично */ }
  };

  const removeOne = async (n) => {
    if (!window.confirm("Удалить это уведомление?")) return;
    try { await list.remove(n.id); notifyInboxChanged(); } catch (e) { /* не критично */ }
  };

  const removeRead = async () => {
    if (!window.confirm("Удалить все прочитанные уведомления?")) return;
    try { await axios.post(`${API}/notifications/inbox/delete-read`); await list.reload(); notifyInboxChanged(); } catch (e) { /* не критично */ }
  };

  return (
    <div className="reversia-card p-6" data-testid="inbox-settings-block">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2 mb-3">
        <h3 className="text-base font-semibold flex items-center gap-2 mr-auto" style={{ fontFamily: "Manrope,sans-serif", color: "var(--rv-text-primary)" }}>
          <Inbox size={16} style={{ color: "var(--rv-teal)" }} />Внутрисайтовые уведомления
          <span className="text-sm font-normal" style={{ color: "var(--rv-text-muted)" }} data-testid="inbox-settings-unread">непрочитанных: {list.unread}</span>
        </h3>
        {list.unread > 0 && <button type="button" onClick={markAll} data-testid="inbox-settings-mark-read" className="text-xs underline" style={{ color: "var(--rv-teal)" }}>Отметить все прочитанными</button>}
        <PageSizeSelect value={size} onChange={setSize} testId="inbox-settings-page-size" />
        <BulkDeleteButton label="Удалить прочитанные" onClick={removeRead} disabled={!list.items.some((n) => n.read)} testId="inbox-settings-delete-read" />
      </div>
      <p className="text-xs mb-3" style={{ color: "var(--rv-text-muted)" }}>Возвраты, отмены, изменения цены и другие события по вашим заданиям. Видны и без подключённых push-уведомлений.</p>
      <div className="rounded-lg overflow-hidden" style={{ border: "1px solid var(--rv-border)" }}>
        <InboxList items={list.items} onOpenTask={onOpenTask} onDelete={removeOne} testPrefix="inbox-settings" />
        <ShowMoreButton shown={list.items.length} total={list.total} size={size} onClick={list.loadMore} testId="inbox-settings-show-more" />
      </div>
      <p className="text-xs mt-2" style={{ color: "var(--rv-text-muted)" }} data-testid="inbox-settings-total">Всего: {list.total}</p>
    </div>
  );
};
